import type { ModuleFolderStructureItem, ModuleFolderStructureOutput, TemplateInfo } from "@scayla/api-client-fetch";

/** Every template of a module's folder structure: the root templates first, then each folder depth-first. */
export function collectModuleTemplates(structure: ModuleFolderStructureOutput): TemplateInfo[] {
  return [...(structure.templates ?? []), ...(structure.folders ?? []).flatMap(collectFolderTemplates)];
}

function collectFolderTemplates(folder: ModuleFolderStructureItem): TemplateInfo[] {
  return [...(folder.templates ?? []), ...(folder.folders ?? []).flatMap(collectFolderTemplates)];
}
